import Link from '@mui/material/Link';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function LoginLink(props) {
  const { t } = useTranslation();
  const { children } = props;

  return (
    <Link
      to="/"
      component={ RouterLink }
      underline="hover"
      sx={{
        mt: 1,
        display: 'flex'
      }}
    >
      <ArrowLeftIcon sx={{ marginLeft: '-24px'}}/>
      {t('auth.common.button.backToLogin')}
    </Link>
  );
}

export default LoginLink;
